import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  showCancelCta: true
} satisfies RecursivePartial<DialogConfig['cartChangeShippingMethod']>
